// imageIndex.js - Índice de imágenes y videos para la galería FeelLab
// Para agregar una nueva imagen:
// 1. Coloca la imagen en la carpeta correspondiente: public/images/gallery/[categoria]/
// 2. Agrega el nombre del archivo a la lista correspondiente abajo
// 3. La imagen aparecerá automáticamente en la galería

export const imageIndex = {
  empatia: [
    'web-001.jpeg',
    'web-002.jpeg',
    'web-003.jpeg',
    'web-004.jpeg',
    'web-005.jpeg',
    'web-006.jpeg',
    'web-007.jpeg',
    'web-008.jpeg',
    'web-009.jpeg',
    'web-0010.jpeg',
    'web-0011.jpeg'
    // Agregar nuevas imágenes aquí siguiendo el patrón web-00X.extension
  ],
  
  arte: [
    'web-001.jpeg',
    'web-002.jpeg',
    'web-003.jpeg',
    'web-004.jpeg',
    'web-005.jpeg',
    'web-006.jpeg',
    'web-007.jpeg',
    'web-008.jpeg',
    'web-009.jpeg',
    'web-0010.jpeg',
    'web-0011.jpeg'
    // Agregar nuevas imágenes aquí siguiendo el patrón web-00X.extension
  ],
  
  emociones: [
    'web-001.jpeg',
    'web-002.jpeg',
    'web-003.jpeg',
    'web-004.jpeg',
    'web-005.jpeg',
    'web-006.jpeg',
    'web-007.jpeg',
    'web-008.jpeg',
    'web-009.jpeg',
    'web-0010.jpeg',
    'web-0011.jpeg'
    // Agregar nuevas imágenes aquí siguiendo el patrón web-00X.extension
  ],
  
  actividades: [
    'web-001.jpeg',
    'web-002.jpeg',
    'web-003.jpeg',
    'web-004.jpeg',
    'web-005.jpeg',
    'web-006.jpeg',
    'web-007.jpeg',
    'web-008.jpeg',
    'web-009.jpeg',
    'web-0010.jpeg',
    'web-0011.jpeg'
    // Agregar nuevas imágenes aquí siguiendo el patrón web-00X.extension
  ],
  
  naturaleza: [
    'web-001.jpeg',
    'web-002.jpeg',
    'web-003.jpeg',
    'web-004.jpeg',
    'web-005.jpeg',
    'web-006.jpeg',
    'web-007.jpeg',
    'web-008.jpeg',
    'web-009.jpeg',
    'web-0010.jpeg',
    'web-0011.jpeg'
    // Agregar nuevas imágenes aquí siguiendo el patrón web-00X.extension
  ]
};

// Índice de videos para la galería
export const videoIndex = {
  empatia: [
    'video1.mp4',
    'video2.mp4'
  ],
  arte: [
    'video3.mp4',
    'video4.mp4'
  ],
  emociones: [
    'video5.mp4',
    'video6.mp4'
  ],
  actividades: [
    'video7.mp4',
    'video8.mp4'
  ],
  naturaleza: []
};

// Metadatos opcionales para las imágenes (títulos personalizados, descripciones, etc.)
export const imageMetadata = {
  empatia: {
    'web-001.jpeg': {
      title: 'Conexión con los animales',
      description: 'Los niños aprenden a conectar emocionalmente con sus compañeros animales'
    },
    'web-002.jpeg': {
      title: 'Momento de cuidado',
      description: 'Desarrollando habilidades de cuidado y responsabilidad'
    },
    'web-003.jpeg': {
      title: 'Empatía en acción',
      description: 'Practicando la comprensión de las necesidades de otros'
    },
    // Agregar metadatos para más imágenes según sea necesario
  },
  
  arte: {
    'web-001.jpeg': {
      title: 'Creatividad animal',
      description: 'Expresando emociones a través del arte inspirado en animales'
    },
    'web-002.jpeg': {
      title: 'Colores de la naturaleza',
      description: 'Explorando la paleta de colores del mundo natural'
    },
    // Agregar metadatos para más imágenes según sea necesario
  },
  
  emociones: {
    'web-001.jpeg': {
      title: 'Reconociendo emociones',
      description: 'Aprendiendo a identificar y expresar sentimientos'
    },
    // Agregar metadatos para más imágenes según sea necesario
  },
  
  actividades: {
    'web-001.jpeg': {
      title: 'Juegos educativos',
      description: 'Actividades lúdicas que fomentan el aprendizaje'
    },
    'web-002.jpeg': {
      title: 'Trabajo en equipo',
      description: 'Colaborando en proyectos de cuidado animal'
    },
    // Agregar metadatos para más imágenes según sea necesario
  },
  
  naturaleza: {
    'web-001.jpeg': {
      title: 'Explorando el jardín',
      description: 'Descubriendo la biodiversidad en nuestro entorno'
    },
    'web-002.jpeg': {
      title: 'Vida silvestre',
      description: 'Observando y respetando la fauna local'
    },
    // Agregar metadatos para más imágenes según sea necesario
  }
};

// Metadatos para videos
export const videoMetadata = {
  empatia: {
    'video1.mp4': {
      title: 'Conexión emocional con animales',
      description: 'Los niños desarrollan empatía hacia los animales en el laboratorio'
    },
    'video2.mp4': {
      title: 'Cuidado responsable',
      description: 'Aprendiendo a cuidar con amor y responsabilidad'
    }
  },
  arte: {
    'video3.mp4': {
      title: 'Arte y creatividad',
      description: 'Expresión artística inspirada en la naturaleza y los animales'
    },
    'video4.mp4': {
      title: 'Taller de pintura',
      description: 'Creando arte con temática animal y emocional'
    }
  },
  emociones: {
    'video5.mp4': {
      title: 'Reconociendo emociones',
      description: 'Identificando sentimientos propios y de otros seres vivos'
    },
    'video6.mp4': {
      title: 'Expresión emocional',
      description: 'Comunicando emociones de forma saludable y empática'
    }
  },
  actividades: {
    'video7.mp4': {
      title: 'Juegos educativos',
      description: 'Actividades lúdicas de aprendizaje sobre empatía animal'
    },
    'video8.mp4': {
      title: 'Trabajo colaborativo',
      description: 'Proyectos en equipo con enfoque en el bienestar animal'
    }
  },
  naturaleza: {}
};

// Función auxiliar para obtener todas las imágenes de una categoría
export const getImagesForCategory = (category) => {
  return imageIndex[category] || [];
};

// Función auxiliar para obtener todos los videos de una categoría
export const getVideosForCategory = (category) => {
  return videoIndex[category] || [];
};

// Función auxiliar para obtener todas las imágenes
export const getAllImages = () => {
  const allImages = [];
  Object.keys(imageIndex).forEach(category => {
    imageIndex[category].forEach(filename => {
      allImages.push({
        category,
        filename,
        metadata: imageMetadata[category]?.[filename] || {}
      });
    });
  });
  return allImages;
};

// Función auxiliar para obtener todos los videos
export const getAllVideos = () => {
  const allVideos = [];
  Object.keys(videoIndex).forEach(category => {
    videoIndex[category].forEach(filename => {
      allVideos.push({
        category,
        filename,
        metadata: videoMetadata[category]?.[filename] || {}
      });
    });
  });
  return allVideos;
};

// Función para validar que el nombre sigue el patrón web-00X.extension
export const validateImageName = (filename) => {
  const pattern = /^web-\d{3}\.(jpeg|jpg|png|gif|webp|svg|bmp|tiff|tif|ico|avif|jfif)$/i;
  return pattern.test(filename);
};

// Función para validar nombres de video
export const validateVideoName = (filename) => {
  const pattern = /^video\d+\.(mp4|webm|ogg|avi|mov|wmv|flv|mkv)$/i;
  return pattern.test(filename);
};